import { icons } from "assets/icons/index"
import { GenericModal } from "components/Modals/GenericModal"
import { useState } from "react"
import { colours } from "styling/colours"
import { style } from "typestyle"

type DeleteModalProps = {
  beacon_id: string
  asset_name?: string
  onClose: () => void
  onDelete: (beacon_id: string) => Promise<any>
}
export const DeleteModal = ({ beacon_id, asset_name, onClose, onDelete }: DeleteModalProps) => {

  const [loading, setLoading] = useState(false)

  const onDeleteRole = async () => {
    setLoading(true)
    onDelete(beacon_id).then(() => {
      setLoading(false)
      onClose()
    })
  }

  if (asset_name) {
    return (<GenericModal
      title="Delete"
      subtitle={
        <span>
          You cannot delete this beacon because it is currently associated with <b>{asset_name}</b> asset.
        </span>
      }
      cancelName="Ok"
      icon={<icons.OutlineDeleteIcon aria-label="Delete Beacon" fill={colours.secondaryText} height={30} width={30} />}
      isOpen
      onClose={onClose}
    />)
  }

  return (<GenericModal
    title="Delete"
    subtitle={
      <span>
        Are you sure you want to permanently delete the beacon with ID: <b>{beacon_id}</b>?
      </span>
    }
    actionName="Delete"
    actionDisabled={loading}
    actionStyle="cancel"
    icon={<icons.OutlineDeleteIcon aria-label="Delete Beacon" className={ModalIconStyle} height={40} width={40} />}
    roundIconStyle={false}
    isOpen
    onClose={onClose}
    onAction={onDeleteRole}
    loading={loading}
  />
  )
}

const ModalIconStyle = style({
  border: "1px solid red",
  borderRadius: "50%",
  padding: "7px",
});
